import { assert, Test } from "oc-e2e-testrunner";
import {
  createElement,
  createMauer,
  logParts,
  resetArrangement,
  verteileGleichmaessigUndAssertGleichmaessigeBreiten,
} from "./utils";
import { v2, v3 } from "oc-threejs/short3";

export default {
  name: "TestStreckeElementeGleichmaessigVerteilen",
};

export const test1mBis10mGrob: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  _.range(1, 10, 0.6).forEach((breite) => {
    agt.grundriss.setStandardForm("Strecke", [breite]);
    const s = agt.segmente[0];
    s.parts = [];
    agt.fillIndividuellSegmentsWithElements();
    verteileGleichmaessigUndAssertGleichmaessigeBreiten(s);
  });
};

export const test10m: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [10]);
  const s = agt.segmente[0];
  agt.fillIndividuellSegmentsWithElements();
  const parts = verteileGleichmaessigUndAssertGleichmaessigeBreiten(s);
  const json = logParts(s, parts);
  assert.deepEquals(
    [
      {
        x0: -0.04,
        x1: 0.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
      {
        x0: 0.02,
        x1: 1.6467,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.6267,
        lichteWeite: 1.5867,
        ecke: false,
      },
      {
        x0: 1.6267,
        x1: 1.7067,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 1.6867,
        x1: 3.3133,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.6267,
        lichteWeite: 1.5867,
        ecke: false,
      },
      {
        x0: 3.2933,
        x1: 3.3733,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 3.3533,
        x1: 4.98,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.6267,
        lichteWeite: 1.5867,
        ecke: false,
      },
      {
        x0: 4.96,
        x1: 5.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 5.02,
        x1: 6.6467,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.6267,
        lichteWeite: 1.5867,
        ecke: false,
      },
      {
        x0: 6.6267,
        x1: 6.7067,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 6.6867,
        x1: 8.3133,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.6267,
        lichteWeite: 1.5867,
        ecke: false,
      },
      {
        x0: 8.2933,
        x1: 8.3733,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 8.3533,
        x1: 9.98,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.6267,
        lichteWeite: 1.5867,
        ecke: false,
      },
      {
        x0: 9.96,
        x1: 10.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
    ],
    json
  );
};

export const test5mMauerRechts: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 5;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  createMauer({ position: v3(breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const parts = verteileGleichmaessigUndAssertGleichmaessigeBreiten(s);
  const json = logParts(s, parts);
  assert.deepEquals(
    [
      {
        x0: -0.04,
        x1: 0.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
      {
        x0: 0.02,
        x1: 1.4833,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.4633,
        lichteWeite: 1.4233,
        ecke: false,
      },
      {
        x0: 1.4633,
        x1: 1.5433,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 1.5233,
        x1: 2.9867,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.4633,
        lichteWeite: 1.4233,
        ecke: false,
      },
      {
        x0: 2.9667,
        x1: 3.0467,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 3.0267,
        x1: 4.49,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.4633,
        lichteWeite: 1.4233,
        ecke: false,
      },
      {
        x0: 4.47,
        x1: 4.5,
        gapLinks: 0,
        gapRechts: 0,
        type: "UMProfil",
        snap: 1,
        breite: 0.03,
        lichteWeite: 0,
        ecke: false,
      },
    ],
    json
  );
};

export const test5mMauerLinks: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 5;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const parts = verteileGleichmaessigUndAssertGleichmaessigeBreiten(s);
  const json = logParts(s, parts);
  assert.deepEquals(
    [
      {
        x0: 0.5,
        x1: 0.53,
        gapLinks: 0,
        gapRechts: 0,
        type: "UMProfil",
        snap: 1,
        breite: 0.03,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 0.51,
        x1: 1.9733,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.4633,
        lichteWeite: 1.4233,
        ecke: false,
      },
      {
        x0: 1.9533,
        x1: 2.0333,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 2.0133,
        x1: 3.4767,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.4633,
        lichteWeite: 1.4233,
        ecke: false,
      },
      {
        x0: 3.4567,
        x1: 3.5367,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 3.5167,
        x1: 4.98,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.4633,
        lichteWeite: 1.4233,
        ecke: false,
      },
      {
        x0: 4.96,
        x1: 5.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
    ],
    json
  );
};

export const test5mMauerLinksRechts: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 5;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  createMauer({ position: v3(breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const parts = verteileGleichmaessigUndAssertGleichmaessigeBreiten(s);
  const json = logParts(s, parts);
  assert.deepEquals(
    [
      {
        x0: 0.5,
        x1: 0.53,
        gapLinks: 0,
        gapRechts: 0,
        type: "UMProfil",
        snap: 1,
        breite: 0.03,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 0.51,
        x1: 1.81,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.3,
        lichteWeite: 1.26,
        ecke: false,
      },
      {
        x0: 1.79,
        x1: 1.87,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 1.85,
        x1: 3.15,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.3,
        lichteWeite: 1.26,
        ecke: false,
      },
      {
        x0: 3.13,
        x1: 3.21,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 3.19,
        x1: 4.49,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.3,
        lichteWeite: 1.26,
        ecke: false,
      },
      {
        x0: 4.47,
        x1: 4.5,
        gapLinks: 0,
        gapRechts: 0,
        type: "UMProfil",
        snap: 1,
        breite: 0.03,
        lichteWeite: 0,
        ecke: false,
      },
    ],
    json
  );
};

export const test5mMauerMitte: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [5]);
  createMauer({ position: v3(0, 0, 0), size: v3(1, 2, 0.2) });
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  verteileGleichmaessigUndAssertGleichmaessigeBreiten(agt.segmente[0]);
  verteileGleichmaessigUndAssertGleichmaessigeBreiten(agt.segmente[1]);
  assert.deepEquals(
    [
      {
        x0: -0.04,
        x1: 0.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
      {
        x0: 0.02,
        x1: 0.985,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 0.965,
        lichteWeite: 0.925,
        ecke: false,
      },
      {
        x0: 0.965,
        x1: 1.045,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 1.025,
        x1: 1.99,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 0.965,
        lichteWeite: 0.925,
        ecke: false,
      },
      {
        x0: 1.97,
        x1: 2,
        gapLinks: 0,
        gapRechts: 0,
        type: "UMProfil",
        snap: 1,
        breite: 0.03,
        lichteWeite: 0,
        ecke: false,
      },
    ],
    logParts(agt.segmente[0], agt.segmente[0].getPartsAndPfosten())
  );
  assert.deepEquals(
    [
      {
        x0: 3,
        x1: 3.03,
        gapLinks: 0,
        gapRechts: 0,
        type: "UMProfil",
        snap: 1,
        breite: 0.03,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 3.01,
        x1: 3.975,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 0.965,
        lichteWeite: 0.925,
        ecke: false,
      },
      {
        x0: 3.955,
        x1: 4.035,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 4.015,
        x1: 4.98,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 0.965,
        lichteWeite: 0.925,
        ecke: false,
      },
      {
        x0: 4.96,
        x1: 5.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
    ],
    logParts(agt.segmente[1], agt.segmente[1].getPartsAndPfosten())
  );
};

export const test4mBis5mGrobMauerLinks: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  _.range(4, 5, 0.01).forEach((breite) => {
    // console.log("teste breite", breite);
    agt.grundriss.setStandardForm("Strecke", [breite]);
    agt.aufbauten = [];
    createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
    const s = agt.segmente[0];
    s.parts = [];
    agt.fillIndividuellSegmentsWithElements();
    verteileGleichmaessigUndAssertGleichmaessigeBreiten(s);
  });
};

export const test411cmMauerLinks: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 4.11;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.aufbauten = [];
  createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  const s = agt.segmente[0];
  s.parts = [];
  agt.fillIndividuellSegmentsWithElements();
  verteileGleichmaessigUndAssertGleichmaessigeBreiten(s);
};

export const testMitTorInMitte: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 10;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  const s = agt.segmente[0];
  const tor = createElement(s, {
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
    size: v2(0.98, 1.8),
  });
  tor.snap = 0;
  s.setX(tor, 0.5, breite / 2);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  tor.snap = 1;
  agt.update3d();
  verteileGleichmaessigUndAssertGleichmaessigeBreiten(s);
};

export const testMitTorRechts: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 5;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const tor = createElement(s, {
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
    size: v2(0.98, 1.8),
  });
  s.setX(tor, 1, breite);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  verteileGleichmaessigUndAssertGleichmaessigeBreiten(s);
};

export const test900cmMauerLinksElementAnMauerFix: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 9;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.aufbauten = [];
  createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  const s = agt.segmente[0];
  s.parts = [];
  createElement(s, {
    size: v2(1.25, 1.8),
  });
  agt.fillIndividuellSegmentsWithElements();
  const selectedParts = s.getElemente().toSpliced(0, 1);
  verteileGleichmaessigUndAssertGleichmaessigeBreiten(s, selectedParts);
};

export const testMasseUnverändertStrecke: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 1;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const vorher = logParts(s, s.parts);
  s.verteileBauseitsKürzbareElementeGleichmäßig(s.parts);
  const nachher = logParts(s, s.parts);
  assert.deepEquals(vorher, nachher);
};
